<template>
  <b-form @submit.prevent="emitOnSearchEvent">
    <b-form-group v-if="isOperator" :label="$t('task.userLogin')">
      <b-form-input v-model="userLogin" />
    </b-form-group>

    <b-form-group :label="$t('task.creationTime')">
      <b-form-select
        v-model="dateRangeType"
        :options="dateRangeTypes"
        v-on:change="dateRangeChanged"
      />
    </b-form-group>

    <b-form-group :label="$t('general.fromDate')">
      <date-picker
        v-model="creationTimeRange.start"
        type="datetime"
        format="DD.MM.YYYY HH:mm:ss"
        input-class="form-control"
        :clearable="false"
        :first-day-of-week="1"
        :lang="locale"
        width="100%"
        confirm
      />
    </b-form-group>

    <b-form-group :label="$t('general.toDate')">
      <date-picker
        v-model="creationTimeRange.end"
        type="datetime"
        format="DD.MM.YYYY HH:mm:ss"
        input-class="form-control"
        :clearable="false"
        :first-day-of-week="1"
        :lang="locale"
        width="100%"
        confirm
      />
    </b-form-group>

    <b-form-group :label="$t('task.type')">
      <b-form-select :options="typeOptions" v-model="type" />
    </b-form-group>

    <b-form-group :label="$t('task.ccmSfdNumber')">
      <b-form-input v-model="ccmSfdNumber"/>
    </b-form-group>

    <!-- search button -->
    <b-form-row class="mx-0">
      <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
        <magnify-icon />
        &nbsp;{{ $t('general.search') }}
      </b-button>
    </b-form-row>
  </b-form>
</template>

<script>
import { DateRangeType, getDateRange } from "@/utils/utils";
import { convertStringsToOptions } from "@/tools/OptionsTools";

export default {
  name: "TaskSearchForm",
  props: {
    tasksService: Object,
    isOperator: Boolean
  },
  data() {
    return {
      userLogin: "",
      creationTimeRange: {
        start: null,
        end: null
      },
      dateRangeType: DateRangeType.LastDay,
      dateTimeFormat: "DD.MM.YYYY HH:mm:ss",
      type: null,
      stateOptions: [],
      typeOptions: [],
      ccmSfdNumber: null
    };
  },
  async mounted() {
    try {
      await this.initialize();
    } catch (errorCode) {
      this.emitOnError(errorCode);
    }
  },
  computed: {
    locale() {
      return this.$store.getters.locale.toLowerCase();
    },
    isDisabled() {
        return this.$store.getters.isLoading
    },
    dateRangeTypes() {
      return [
        { value: DateRangeType.LastHour, text: this.$t("general.lastHour") },
        {
          value: DateRangeType.Last12Hours,
          text: this.$t("general.last12Hours")
        },
        { value: DateRangeType.LastDay, text: this.$t("general.lastDay"), selected: true }
      ];
    }
  },
  methods: {
    // all side effect in the method
    async initialize() {
      const defaultLabel = this.$t("general.select");

      const types = await this.tasksService.getTypes();

      this.typeOptions = convertStringsToOptions(
        types,
        s => this.$t(`task.types.${s}`),
        defaultLabel
      );
      
      this.dateRangeChanged(DateRangeType.LastDay);
    },
    
    dateRangeChanged(rangeType) {
        if (rangeType != null) {
            const dateRange = getDateRange(rangeType);
            this.creationTimeRange.start = dateRange.start;
            this.creationTimeRange.end = dateRange.end;
        }
    },

    emitOnSearchEvent() {
      const filter = {
        creator: this.userLogin,
        creationTimeFrom: this.creationTimeRange.start,
        creationTimeTo: this.creationTimeRange.end,
        type: this.type,
        ccmSfdNumber: this.ccmSfdNumber
      };

      this.$emit("onSearch", filter);
    },

    emitOnError(errorCode) {
      this.$emit("onError", errorCode);
    }
  }
};
</script>